import AuthState from '@/types/store/auth/AuthState';

const state: AuthState = {};

export default state;
